import store from '@/store'

const installed = (to, from, next) => {
  const isCashRegisterInstalled = store.getters.isCashRegisterInstalled
  if (!isCashRegisterInstalled && to.path !== '/installation') {
    return next('/installation')
  }

  next()
}

export default installed



// WEBPACK FOOTER //
// ./src/router/guards/installed.js